/*
 * ===============================================================================================================
 *                                Copyright 2024, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */

import { fetchLocationsToRoleFailure, fetchLocationsToRoleRequest, fetchLocationsToRoleSuccess } from './locationToRoleActionCreator';
import { getLocationsToRole } from '../../../services/roles';
import { setSnackBarMessage } from '../../snackBar/snackBarActionCreator';
import { SNACKBAR_ALERT_DEFAULT_PROPS } from '../../../container/Roles/constants';

export async function fetchLocationsToRole(dispatch: Function, roleId: string | number, searchParams: any) {
  dispatch(fetchLocationsToRoleRequest());
  try {
    const { data, metadata } = await getLocationsToRole(roleId, searchParams);
    dispatch(fetchLocationsToRoleSuccess(data, metadata));
  } catch (error: any) {
    dispatch(fetchLocationsToRoleFailure(error));
    dispatch(
      setSnackBarMessage({
        ...SNACKBAR_ALERT_DEFAULT_PROPS,
        message: error && 'Something went wrong',
        severity: 'error'
      })
    );
  }
}
